/* @jsx jsx */
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { LogoSvg } from '../../assets/Logo';
import messages from './messages';
import { logoContainer } from './styles';
export const AtlassianIntelligenceLogo = ({
  isDisabled = false
}) => {
  const {
    formatMessage
  } = useIntl();
  return jsx("div", {
    "data-testid": "atlassian-intelligence-logo",
    css: logoContainer
  }, jsx(LogoSvg, {
    alt: formatMessage(messages.logoAltText),
    isDisabled: isDisabled
  }));
};